import { GenericSuspense, Menu, useSetCurrentDocumentTitle } from "@harea/component";
import { useEffect } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useGroupDetailsMenuTabs } from "../hooks/useGroupDetailsMenuTabs";
import { useGroupsOrganisationQuery } from "../../../hooks/useGroupsOrganisationQuery";

export const GroupsDetailsContainer = () => {
    const [, , , , , , , , tab, ] = location.pathname.split("/");
    const { groupId } = useParams();
    const { data } = useGroupsOrganisationQuery(parseInt(groupId), true);
    const menus = useGroupDetailsMenuTabs(parseInt(groupId));
    const navigate = useNavigate();
    useSetCurrentDocumentTitle(`UserOrganisationDesignation`, data?.name)

    useEffect(() => {
        if (!menus.some((item) => item?.ke === tab)) {
            navigate(menus[0].link);
        }
    }, [menus, tab]);

    return (
        <section className="main-content">
            <div className="flex items-center justify-between">
                <h4 className="font-semibold">{data?.name}</h4>
            </div>

            <Menu
                type="HORIZONTAL"
                className="menu-tabs"
                items={menus}
                activeFn={(menu) => menu.ke === tab}
            />

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </section>
    );
};